import types from './types';

const actions = dispatch => {
  return {
    setRangeDays: ({ startDate, endDate, rangeOption, silent = true }) => {
      dispatch({
        type: types.SET_RANGE_DAYS,
        payload: { startDate, endDate, rangeOption },
      });
    },
    setUseCase: ({ useCase, silent = true }) => {
      dispatch({ type: types.SET_USE_CASE_TYPE, payload: useCase });
    },
  };
};

export default actions;
